<div class="voice-navigation">
    <h2>Voice Navigation</h2>
    <p>Click the button below and say "בית", "אודות", or "צור קשר" to navigate.</p>
  
    <button (click)="startListening()" [disabled]="listening">Start Listening</button>
  
    <p *ngIf="transcript">You said: "{{ transcript }}"</p>
  </div>
  